import { queryOptions, useQuery } from '@tanstack/react-query';

import { QueryOptions } from '@cast/shared-types';
import { DboCloudSyncStatus } from '@cast/types-database-optimizer';

import { apiClient } from '@cast/infrastructure-api';
import { useCurrentOrganizationId } from '@cast/infrastructure-organization';

const CLOUD_SYNC_STATUS_QUERY_KEY = 'cloud-sync-status';

export const useCloudSyncStatusQuery = (
  options?: QueryOptions<DboCloudSyncStatus>
) => {
  const organizationId = useCurrentOrganizationId();

  const { data: syncStatus, ...rest } = useQuery(
    queryOptions({
      queryKey: [CLOUD_SYNC_STATUS_QUERY_KEY, organizationId],
      queryFn: async () => {
        const { data } = await apiClient.dbo.getCloudSyncStatus({
          organizationId,
        });
        return data;
      },
      ...options,
    })
  );

  return {
    syncStatus,
    ...rest,
  };
};
